import {
  PageResponse,
  PageData,
  Cube2COrderQuery,
  Cube2COrder,
  Cube2BOrderQuery,
  Cube2BOrder,
} from "@/types";
import { CubeOrderAPI } from "../shared";

export async function query2COrders(
  params?: Cube2COrderQuery,
): Promise<PageData<Cube2COrder>> {
  return CubeOrderAPI.get<PageResponse<Cube2COrder>>({
    url: "2c",
    params,
  }).then((res) => res.data);
}

export async function query2BOrders(
  params?: Cube2BOrderQuery,
): Promise<PageData<Cube2BOrder>> {
  return CubeOrderAPI.get<PageResponse<Cube2BOrder>>({
    url: "2b",
    params,
  }).then((res) => res.data);
}
